export default "__VITE_PUBLIC_ASSET__1fdb775a__"